import { render, staticRenderFns } from "./LegalTexts.html?vue&type=template&id=a9cbd7c8&external"
import script from "./LegalTexts.ts?vue&type=script&lang=ts&external"
export * from "./LegalTexts.ts?vue&type=script&lang=ts&external"
import style0 from "./LegalTexts.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports